import React from 'react';
import { ISignificanceTableData } from '../../interfaces';
import { assertNotNil } from '../../../../utils/types';
import SignificanceTableVariant from './SignificanceTableVariant/SignificanceTableVariant';
import SignificanceChartControl from './SignificanceChartControl';
import * as SignificanceTableUI from './SignificanceTableUI';
import { MetricTypeKey } from '../../../../utils/apollo/graphqlSchema';

interface IProps {
  data: ISignificanceTableData;
  metricTypeKey: MetricTypeKey;
}

const SignificanceTable = ({ data, metricTypeKey }: IProps) => {
  const { metricName, control, variantA, variantB, leadingVariant } = data;
  assertNotNil(control);
  assertNotNil(variantA);

  return (
    <SignificanceTableUI.Container>
      <SignificanceTableUI.Table>
        <thead>
          <tr>
            <SignificanceTableUI.HeaderCell>
              Metric
            </SignificanceTableUI.HeaderCell>
            <SignificanceTableUI.HeaderCell>
              Control
            </SignificanceTableUI.HeaderCell>
            <SignificanceTableUI.HeaderCell>
              Variant A
            </SignificanceTableUI.HeaderCell>
            {variantB && (
              <SignificanceTableUI.HeaderCell>
                Variant B
              </SignificanceTableUI.HeaderCell>
            )}
          </tr>
        </thead>
        <tbody>
          <tr>
            <SignificanceTableUI.BodyCell>
              <SignificanceTableUI.VariantName>
                {metricName}
              </SignificanceTableUI.VariantName>
            </SignificanceTableUI.BodyCell>
            <SignificanceTableUI.BodyCell>
              <SignificanceChartControl control={control} />
            </SignificanceTableUI.BodyCell>
            <SignificanceTableVariant
              variant={variantA}
              isLeading={leadingVariant === 'variantA'}
              metricTypeKey={metricTypeKey}
              label={`Variant A - ${variantA.variant}`}
            />
            {variantB && (
              <SignificanceTableVariant
                variant={variantB}
                isLeading={leadingVariant === 'variantB'}
                metricTypeKey={metricTypeKey}
                label={`Variant B - ${variantB.variant}`}
              />
            )}
          </tr>
        </tbody>
      </SignificanceTableUI.Table>
    </SignificanceTableUI.Container>
  );
};

export default SignificanceTable;
